/* ==========================================================================
   Catalogue — vertical product list
   One lightbox for the whole page, one set of delegated listeners.
   Replaces the previous Swiper-based implementation (2 instances + 1 overlay
   per product) — nothing here needs a third-party library.
   Safe to load once per page and safe under `shopify:section:load`.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__bpCatalogueReady) return;
  window.__bpCatalogueReady = true;

  var GALLERY_SEP = '|';

  var lightbox = null;
  var frameImg = null;
  var nameEl = null;
  var dotsEl = null;
  var counterEl = null;
  var gallery = [];
  var index = 0;
  var lastFocused = null;

  /* --- Page scroll lock --------------------------------------------------- *
     Overlays stack: a lightbox opens on top of a case study, which may itself
     sit over the specs sheet. Each one used to set and clear the lock on its
     own, so closing the topmost released the page while the one underneath was
     still open. Only the last overlay out clears it now.
     ----------------------------------------------------------------------- */

  var OVERLAYS_OPEN =
    '.bpc-lightbox.is-open, .bpc-sheet.is-open, .bpc-pd.is-open, ' +
    '.bpc-modal.is-open, .bpl-overlay.is-open, .blueprint-modal-overlay.is-active';

  function lockScroll() {
    document.documentElement.style.overflow = 'hidden';
  }

  function releaseScroll() {
    // Callers remove their own `is-open` before calling this, so anything
    // still matching is an overlay that is genuinely still open.
    if (document.querySelector(OVERLAYS_OPEN)) return;
    document.documentElement.style.overflow = '';
  }

  window.blueprintCatalogue = window.blueprintCatalogue || {};
  window.blueprintCatalogue.lockScroll = lockScroll;
  window.blueprintCatalogue.releaseScroll = releaseScroll;

  /* --- Lightbox ---------------------------------------------------------- */

  function buildLightbox() {
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'bpc-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Product photos');
    lightbox.innerHTML = [
      '<div class="bpc-lightbox-inner">',
      '<button type="button" class="bpc-lightbox-close" data-bpc-close>Close &#10005;</button>',
      '<div class="bpc-lightbox-frame"><img alt=""></div>',
      '<button type="button" class="bpc-lightbox-nav bpc-lightbox-prev" data-bpc-prev aria-label="Previous photo">&#8249;</button>',
      '<button type="button" class="bpc-lightbox-nav bpc-lightbox-next" data-bpc-next aria-label="Next photo">&#8250;</button>',
      '<div class="bpc-lightbox-caption">',
      '<span data-bpc-name></span>',
      '<span data-bpc-counter></span>',
      '<div class="bpc-lightbox-dots" data-bpc-dots></div>',
      '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(lightbox);

    frameImg = lightbox.querySelector('.bpc-lightbox-frame img');
    nameEl = lightbox.querySelector('[data-bpc-name]');
    dotsEl = lightbox.querySelector('[data-bpc-dots]');
    counterEl = lightbox.querySelector('[data-bpc-counter]');

    return lightbox;
  }

  function render() {
    frameImg.src = gallery[index];
    frameImg.alt = (nameEl.textContent || 'Product') + ' — photo ' + (index + 1);
    counterEl.textContent = gallery.length > 1 ? index + 1 + ' / ' + gallery.length : '';

    var dots = '';
    for (var i = 0; i < gallery.length; i++) {
      dots +=
        '<button type="button" class="bpc-lightbox-dot' +
        (i === index ? ' is-active' : '') +
        '" data-bpc-dot="' +
        i +
        '" aria-label="Photo ' +
        (i + 1) +
        '"></button>';
    }
    dotsEl.innerHTML = dots;
  }

  function open(urls, name, start) {
    if (!urls.length) return;

    buildLightbox();
    lastFocused = document.activeElement;
    gallery = urls;
    index = Math.min(Math.max(parseInt(start, 10) || 0, 0), gallery.length - 1);
    nameEl.textContent = name || '';
    lightbox.setAttribute('data-single', gallery.length > 1 ? 'false' : 'true');
    render();
    lightbox.classList.add('is-open');
    lockScroll();
    lightbox.querySelector('[data-bpc-close]').focus();
  }

  function close() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    releaseScroll();
    frameImg.src = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  function step(delta) {
    if (gallery.length < 2) return;
    index = (index + delta + gallery.length) % gallery.length;
    render();
  }

  function isOpen() {
    return !!lightbox && lightbox.classList.contains('is-open');
  }

  // Shared so catalogue-projects.js can reuse this lightbox instead of shipping
  // a second one.
  window.blueprintCatalogue = window.blueprintCatalogue || {};
  window.blueprintCatalogue.openLightbox = function (urls, name, startIndex) {
    if (!urls || !urls.length) return;
    open(urls, name);
    if (startIndex) {
      index = Math.min(Math.max(startIndex, 0), urls.length - 1);
      render();
    }
  };
  window.blueprintCatalogue.closeLightbox = close;

  /* --- Full specs sheet -------------------------------------------------- */

  var sheet = null;
  var sheetScroll = null;
  var sheetReturn = null;

  function buildSheet() {
    if (sheet) return sheet;

    sheet = document.createElement('div');
    sheet.className = 'bpc-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = [
      '<div class="bpc-sheet-card">',
      '<div class="bpc-sheet-handle" aria-hidden="true"></div>',
      '<div class="bpc-sheet-head">',
      '<div><h3 data-bpc-sheet-title></h3><div class="bpc-sheet-sub" data-bpc-sheet-sub></div></div>',
      '<button type="button" class="bpc-sheet-close" data-bpc-sheet-close aria-label="Close">&#10005;</button>',
      '</div>',
      '<div class="bpc-sheet-scroll"></div>',
      '<div class="bpc-sheet-actions" data-bpc-sheet-actions></div>',
      '</div>'
    ].join('');

    document.body.appendChild(sheet);
    sheetScroll = sheet.querySelector('.bpc-sheet-scroll');
    return sheet;
  }

  function openSheet(trigger) {
    var id = trigger.getAttribute('data-bpc-fullspecs');
    var template = document.querySelector('[data-bpc-sheet-body="' + id + '"]');
    if (!template) return;

    buildSheet();
    sheetReturn = trigger;

    sheet.querySelector('[data-bpc-sheet-title]').textContent = trigger.getAttribute('data-bpc-title') || '';
    sheet.querySelector('[data-bpc-sheet-sub]').textContent = trigger.getAttribute('data-bpc-sheet-sub') || '';

    sheetScroll.textContent = '';
    sheetScroll.appendChild(template.content.cloneNode(true));
    sheetScroll.scrollTop = 0;

    // Buttons come from the row so the sheet stays generic.
    var actions = sheet.querySelector('[data-bpc-sheet-actions]');
    var pdf = trigger.getAttribute('data-bpc-pdf');
    var pdfLabel = trigger.getAttribute('data-bpc-pdf-label') || 'Download PDF';
    var sampleLabel = trigger.getAttribute('data-bpc-sample-label') || 'Request Sample';

    var html = '';
    if (pdf) {
      html +=
        '<a class="bpc-sheet-btn bpc-sheet-btn--ghost" href="' + pdf + '" target="_blank" rel="noopener">' + pdfLabel + '</a>';
    }
    // Same contact modal the row CTA opens, so both sample paths behave alike.
    html +=
      '<button type="button" class="bpc-sheet-btn bpc-sheet-btn--solid js-open-modal" data-bpc-sheet-sample>' +
      sampleLabel +
      '</button>';
    actions.innerHTML = html;
    actions.style.display = html ? '' : 'none';

    sheet.classList.add('is-open');
    lockScroll();
    sheet.querySelector('[data-bpc-sheet-close]').focus();
  }

  function closeSheet() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    releaseScroll();
    if (sheetReturn && typeof sheetReturn.focus === 'function') sheetReturn.focus();
    sheetReturn = null;
  }

  function sheetOpen() {
    return !!sheet && sheet.classList.contains('is-open');
  }

  /* --- Installed panel bookkeeping ---------------------------------------- *
     A product's installed photos are nested theme blocks, so Liquid cannot
     count them: the empty state ships rendered and is hidden here once any
     photo exists — the product's own, or a project strip appended by
     catalogue-projects.js.

     Mobile shows a fixed number per strip and hides the rest. That used to be
     a hard-coded `nth-child(n + 5)`, which silently swallowed photo 5 onward;
     now the cut-off is a section setting and the last visible photo carries a
     "+N" badge, because tapping any photo opens the whole set anyway.
     ----------------------------------------------------------------------- */

  var MOBILE_MAX_DEFAULT = 4;

  function markOverflow(grid, limit) {
    var photos = grid.querySelectorAll('.bpc-installed-photo');
    for (var i = 0; i < photos.length; i++) {
      photos[i].classList.toggle('bpc-inst-over', i >= limit);
      photos[i].removeAttribute('data-bpc-more');
    }
    if (photos.length > limit && limit > 0) {
      photos[limit - 1].setAttribute('data-bpc-more', '+' + (photos.length - limit));
    }
  }

  function syncInstalled() {
    document.querySelectorAll('.bpc-installed-body').forEach(function (body) {
      var own = body.querySelector('[data-bpc-own-grid]');
      var limit = MOBILE_MAX_DEFAULT;
      if (own) {
        limit = parseInt(own.getAttribute('data-bpc-mobile-max'), 10) || MOBILE_MAX_DEFAULT;
        // An empty own-grid would still eat its flex gap, so take it out.
        own.hidden = !own.querySelector('.bpc-installed-photo');
      }

      var empty = body.querySelector('.bpc-installed-empty');
      if (empty) empty.hidden = !!body.querySelector('.bpc-installed-photo');

      body.querySelectorAll('.bpc-installed-grid').forEach(function (grid) {
        markOverflow(grid, limit);
      });
    });
  }

  /* Every installed photo in the same strip is one gallery, assembled here
     rather than in Liquid: a parent theme block cannot read its children, and
     the old markup repeated all four urls on every button. */
  function ownGallery(photo) {
    var grid = photo.closest('.bpc-installed-grid');
    if (!grid) return { urls: [photo.getAttribute('data-bpc-full')], start: 0 };

    var urls = [];
    var start = 0;
    grid.querySelectorAll('.bpc-installed-photo[data-bpc-full]').forEach(function (node) {
      if (node === photo) start = urls.length;
      urls.push(node.getAttribute('data-bpc-full'));
    });
    return { urls: urls, start: start };
  }

  window.blueprintCatalogue = window.blueprintCatalogue || {};
  window.blueprintCatalogue.syncInstalled = syncInstalled;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncInstalled);
  } else {
    syncInstalled();
  }

  // The theme editor re-renders a section on every block edit — adding an
  // installed photo has to re-run the count.
  document.addEventListener('shopify:section:load', syncInstalled);

  document.addEventListener('shopify:block:select', function (event) {
    syncInstalled();

    // Selecting an installed photo has to open the panel it lives in: the row
    // is collapsed on desktop, so the photo being edited would be invisible.
    var el = event.target;
    var panel = el && el.closest ? el.closest('.bpc-installed-panel') : null;
    if (!panel) return;

    panel.classList.add('is-open');
    var toggle = document.querySelector('[data-bpc-toggle="' + panel.id + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  });

  /* --- Delegated events -------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var target = event.target;

    // Open from a product thumbnail or an "installed" photo.
    var opener = target.closest('[data-bpc-gallery]');
    if (opener) {
      event.preventDefault();
      var raw = opener.getAttribute('data-bpc-gallery') || '';
      var urls = raw.split(GALLERY_SEP).filter(Boolean);
      open(urls, opener.getAttribute('data-bpc-name') || '');
      return;
    }

    // A product's own installed photo: open the strip it belongs to, on itself.
    var installed = target.closest('.bpc-installed-photo[data-bpc-full]');
    if (installed) {
      event.preventDefault();
      var row = installed.closest('.bpc-row');
      var set = ownGallery(installed);
      var label = installed.getAttribute('data-bpc-caption');
      if (!label) {
        label = (row ? row.getAttribute('data-bpc-product') : '') + ' \u2014 installed';
      }
      open(set.urls, label, set.start);
      return;
    }

    var fullSpecs = target.closest('[data-bpc-fullspecs]');
    if (fullSpecs) {
      event.preventDefault();
      openSheet(fullSpecs);
      return;
    }

    if (sheetOpen()) {
      if (target === sheet || target.closest('[data-bpc-sheet-close]')) {
        closeSheet();
        return;
      }
      // Let the theme's contact modal take over cleanly.
      if (target.closest('[data-bpc-sheet-sample]')) {
        closeSheet();
      }
    }

    // Collapsible specs / installed panel.
    var toggle = target.closest('[data-bpc-toggle]');
    if (toggle) {
      event.preventDefault();
      var panel = document.getElementById(toggle.getAttribute('data-bpc-toggle'));
      if (!panel) return;
      var next = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(next));
      panel.classList.toggle('is-open', next);
      return;
    }

    if (!isOpen()) return;

    if (target.closest('[data-bpc-close]') || target === lightbox) {
      close();
      return;
    }
    if (target.closest('[data-bpc-prev]')) {
      step(-1);
      return;
    }
    if (target.closest('[data-bpc-next]')) {
      step(1);
      return;
    }

    var dot = target.closest('[data-bpc-dot]');
    if (dot) {
      index = parseInt(dot.getAttribute('data-bpc-dot'), 10) || 0;
      render();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && sheetOpen()) {
      closeSheet();
      return;
    }

    if (!isOpen()) return;

    if (event.key === 'Escape') {
      close();
    } else if (event.key === 'ArrowLeft') {
      step(-1);
    } else if (event.key === 'ArrowRight') {
      step(1);
    } else if (event.key === 'Tab') {
      // Keep focus inside the dialog.
      var focusables = lightbox.querySelectorAll('button');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  /* --- Swipe on the lightbox frame --------------------------------------- */

  var touchX = null;

  document.addEventListener(
    'touchstart',
    function (event) {
      if (!isOpen()) return;
      touchX = event.touches[0].clientX;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (!isOpen() || touchX === null) return;
      var delta = event.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 45) step(delta < 0 ? 1 : -1);
      touchX = null;
    },
    { passive: true }
  );
})();
